export default {
  SAV: {
    backgroundColor: "#f72585",
  },
  TLV: {
    backgroundColor: "#b5179e",
  },
  ADV: {
    backgroundColor: "#7209b7",
  },
  STRONG: {
    backgroundColor: "#38a3a5",
  },
  SAVREP: {
    backgroundColor: "#affc41",
  },
  QUALITE: {
    backgroundColor: "#57cc99",
  },
  WEB: {
    backgroundColor: "#4361ee",
  },
  COMTPA: {
    backgroundColor: "#4895ef",
  },
  MARKETING: {
    backgroundColor: "#3f37c9",
  },
  ADMIN: {
    backgroundColor: "#4cc9f0",
  },
  STATS: {
    backgroundColor: "#6c757d",
  },
};
